<div class="wrapper" [ngClass]="{ios:iOS(), android:android()}">
  <input
    type="email"
    placeholder="Email"
    formControlName="email"
    #focus
    autocomplete="on"
    (keyup.enter)="onPressEnter()"
  />
  @if(isValid$ | async){
  <icon name="ph:check-fat-fill" color="primary-color" size="24" />
  } @else {
  <icon name="ph:check-fat" color="accent-color" size="24" />
  }
</div>
